import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import info from './info'
import username from './username'
import email from './email'
import sms from './sms'
import twoFactor from './two-factor'
import password from './password'
import winLoss from './win-loss'
/**
* @see \App\Http\Controllers\AccountController::reverify
 * @see app/Http/Controllers/AccountController.php:401
 * @route '/account/reverify'
 */
export const reverify = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reverify.url(options),
    method: 'post',
})

reverify.definition = {
    methods: ["post"],
    url: '/account/reverify',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AccountController::reverify
 * @see app/Http/Controllers/AccountController.php:401
 * @route '/account/reverify'
 */
reverify.url = (options?: RouteQueryOptions) => {
    return reverify.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountController::reverify
 * @see app/Http/Controllers/AccountController.php:401
 * @route '/account/reverify'
 */
reverify.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reverify.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AccountController::reverify
 * @see app/Http/Controllers/AccountController.php:401
 * @route '/account/reverify'
 */
    const reverifyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: reverify.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AccountController::reverify
 * @see app/Http/Controllers/AccountController.php:401
 * @route '/account/reverify'
 */
        reverifyForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: reverify.url(options),
            method: 'post',
        })
    
    reverify.form = reverifyForm
/**
* @see \App\Http\Controllers\AccountController::offers
 * @see app/Http/Controllers/AccountController.php:194
 * @route '/account/offers'
 */
export const offers = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: offers.url(options),
    method: 'get',
})

offers.definition = {
    methods: ["get","head"],
    url: '/account/offers',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AccountController::offers
 * @see app/Http/Controllers/AccountController.php:194
 * @route '/account/offers'
 */
offers.url = (options?: RouteQueryOptions) => {
    return offers.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountController::offers
 * @see app/Http/Controllers/AccountController.php:194
 * @route '/account/offers'
 */
offers.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: offers.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AccountController::offers
 * @see app/Http/Controllers/AccountController.php:194
 * @route '/account/offers'
 */
offers.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: offers.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AccountController::offers
 * @see app/Http/Controllers/AccountController.php:194
 * @route '/account/offers'
 */
    const offersForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: offers.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AccountController::offers
 * @see app/Http/Controllers/AccountController.php:194
 * @route '/account/offers'
 */
        offersForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: offers.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AccountController::offers
 * @see app/Http/Controllers/AccountController.php:194
 * @route '/account/offers'
 */
        offersForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: offers.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    offers.form = offersForm
const account = {
    reverify: Object.assign(reverify, reverify),
info: Object.assign(info, info),
username: Object.assign(username, username),
email: Object.assign(email, email),
sms: Object.assign(sms, sms),
twoFactor: Object.assign(twoFactor, twoFactor),
password: Object.assign(password, password),
winLoss: Object.assign(winLoss, winLoss),
offers: Object.assign(offers, offers),
}

export default account